import React from 'react';
import { motion } from 'framer-motion';
import { Scale } from 'lucide-react';
export const Solution = () => {
  return <section className="py-12 bg-legal-800 relative overflow-hidden" data-id="element-237" data-mp="1ejj98hqajvlq">
      {/* Decorative scale background */}
      <div className="absolute -right-20 -top-20 text-legal-700/20 pointer-events-none" data-id="element-238" data-mp="10so5tkyka6pj">
        <Scale className="w-96 h-96" data-id="element-239" data-mp="15qzehsd4eb66" />
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-240" data-mp="quzyzwnol8r0">
        <div className="max-w-3xl mx-auto text-center" data-id="element-241" data-mp="qtgkobll57rv">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-242" data-mp="vumde9f8wv1e">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold-500/10 mb-6" data-id="element-243" data-mp="2c69tf1orw08y">
              <Scale className="w-8 h-8 text-gold-500" data-id="element-244" data-mp="2h537av7z1t9n" />
            </div>

            <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-245" data-mp="6yxjwdws8e97">
              Presentamos el sistema definitivo para{' '}
              <span className="text-gold-500" data-id="element-246" data-mp="gqthlnuyi2cw">abogados.</span>
            </h2>

            <p className="text-lg md:text-xl text-slate-300 mb-8 leading-relaxed" data-id="element-247" data-mp="brqp12w5xolt">
              Es una <strong data-id="element-248" data-mp="3k7af5t1jeqwn">biblioteca profesional</strong> diseñada para que
              cualquier abogado pueda trabajar con mayor rapidez, seguridad y
              respaldo profesional.
            </p>

            <div className="h-1 w-24 bg-gold-500 mx-auto rounded-full" data-id="element-249" data-mp="3u5gf453s9myv"></div>
          </motion.div>
        </div>
      </div>
    </section>;
};